import React, { Component } from "react";
import { connect } from "react-redux";
import { func } from "prop-types";

import { go, next } from "../../logic/actions/navigation";
import Icon from "../Icon";
import PageContent from "../PageContent";
import { challengeCreate } from "../../logic/actions/api/liveness";
import { INSTRUCTION_VIDEO_SELFIE } from "../../logic/enums/pages";
import { isMobile } from "../../logic/deviceType";
export class PageFaceCaptureInstructions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLivenessChallengeLoaded: false,
    };
  }

  static propTypes = {
    go: func,
    challengeCreate: func,
  };

  componentDidMount() {
    if (!this.props.livenessTestData) {
      this.props
        .challengeCreate() //we need information about liveness data and which liveness challange should we perform...
        .then(() => this.setState({ isLivenessChallengeLoaded: true }))
        .catch((err) => {
          console.error(err);
          this.setState({
            error:
              "Failed to get liveness challenge, please contact your support.",
          });
        });
    } else {
      this.setState({ isLivenessChallengeLoaded: true });
    }
    if (window.location.href.slice(5) !== "start") {
      window.history.pushState({}, null, "start");
    }
  }

  nextPage() {
    if (this.state.isLivenessChallengeLoaded) this.props.next();
  }

  render() {
    const buttonClassName =
      this.state.error || !this.state.isLivenessChallengeLoaded
        ? "btn gray"
        : "btn blue";

    return (
      <PageContent
        toggleLoading={this.state.pending}
        progressBar={true}
        progressPercentage={40}
      >
        <header></header>
        <h1>Selfie</h1>
        <p className="center">Take a selfie showing your face.</p>
        <div className="panel border-green">
          <div className="column">
            <div className="row">
              <Icon name="Light" color="gray" />
              <p>Make sure you are in a well-lit area</p>
            </div>
            <hr />
            <div className="row">
              <Icon name="Focus" color="gray" />
              <p>You're in front of a plain background</p>
            </div>
            <hr />
            <div className="row">
              <Icon name="Hat" color="gray" />
              <p>
                Remove hats, thick glasses or anything else that hides your face
              </p>
            </div>
            <hr />
            <div className="row">
              <Icon name="Face" color="gray" />
              <p>Keep your expression neutral</p>
            </div>
          </div>
        </div>
        <p className="error">{this.state.error}</p>
        <button
          className={buttonClassName}
          onClick={() => {
            isMobile(navigator.userAgent)
              ? this.props.go(INSTRUCTION_VIDEO_SELFIE)
              : this.props.next();
          }}
        >
          Continue
        </button>
      </PageContent>
    );
  }
}
export default connect(
  (store) => {
    return {
      livenessTestData: store.livenessTest.livenessTestData,
    };
  },
  { go, next, challengeCreate }
)(PageFaceCaptureInstructions);
